import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  state: {
    data: [],
    count: null,
    isLoading: false
  },
  actions,
  mutations,
  getters,
  namespaced: true
}
